module.exports = "<p>\n  printbill works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/printbill/printbill.component.html
// module id = ../../../../../src/app/printbill/printbill.component.html
// module chunks = main